import "../App.scss";
import "../styles/header.scss";
import logo from "../assets/img/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Data } from "../Location";
import headerBtn from "../assets/img/headerBtn.png";
export function Header() {
    const [openMenu, setOpenMenu] = useState(false);
    const [m, setMenu] = useState("");
    const menu = useRef(null);
    const menuHeight = 169;
    const [data, setData] = useState(false);
    const location = useLocation();
    useEffect(() => {
        setMenu("");
        setOpenMenu(false);
        menu.current.style.height = "0px";
        Data().then((r) => {
            setData(r);
        });
    }, [location]);
    return (
        <div className="header">
            <div className="logoSide">
                <img src={logo}></img>
            </div>
            <div className={"navSide " + m}>
                <Link
                    className={
                        "navLink " + (location.pathname === "/" ? "active" : "")
                    }
                    to="/"
                >
                    {data ? data.header.Home : ""}
                </Link>
                <Link
                    className={
                        "navLink " +
                        (location.pathname === "/about" ? "active" : "")
                    }
                    to="/about"
                >
                    {data ? data.header.About : ""}
                </Link>
                {/* <div className="navLink" onClick={() => {
                    if(openMenu){
                        menu.current.style.height = "0px";
                        setOpenMenu(false)
                    }else{
                        menu.current.style.height = `${menuHeight}px`;
                        setOpenMenu(true)
                    }
                }}>Үйлчилгээ {openMenu? <>&#9650;</>:<>&#9660;</>}</div> */}
                <Link
                    className={
                        "navLink " +
                        (location.pathname === "/archive" ? "active" : "")
                    }
                    to="/archive"
                >
                    {data ? data.header.Travels : ""}
                </Link>
                <div className="navLink lan" onClick={() => {
                    localStorage.setItem("language", localStorage.getItem("language") === "mn" ? "en" : "mn");
                    window.location.reload();
                }}>
                    {localStorage.getItem("language", "en") === "mn" ? "EN":"MN"}
                </div>
            </div>
            <div className="Menu" ref={menu}>
                <Link className="navLink" to="/archive">
                    fishing
                </Link>
                <Link className="navLink" to="/archive">
                    fishing
                </Link>
                <Link className="navLink" to="/archive">
                    fishing
                </Link>
                <Link className="navLink" to="/archive">
                    fishing
                </Link>
            </div>
            <div
                className="headerBtn"
                onClick={() => {
                    if (m.length > 1) {
                        setMenu("");
                    } else {
                        setMenu("active");
                    }
                    console.log(m);
                }}
            >
                <img src={headerBtn}></img>
            </div>
        </div>
    );
}
